import Machine from '../types/api/machine'

export type RecordWithStampRoller = {
    withoutCutting?: boolean
    stamp?: { roller?: { documentId?: string } | null } | null
    virtualStamp?: { roller?: { documentId?: string } | null } | null
}

/**
 * Подходит ли станок под вал штампа (у станка в rollers есть вал штампа).
 * Используется в колонке «Станок» и в обёртке выбора бренда станка.
 */
export function machineHasStampRoller(
    machine: Machine | undefined,
    record: RecordWithStampRoller | undefined
): boolean {
    const stampRoller = record?.withoutCutting
        ? record?.virtualStamp?.roller
        : record?.stamp?.roller
    if (!stampRoller?.documentId) return false
    if (machine?.name === 'Durst 1' || machine?.name === 'DCMQ 1' || machine?.name === 'WG 1')
        return true
    return machine?.rollers?.some(x => x.documentId === stampRoller.documentId) ?? false
}
